import {Injectable} from '@angular/core';
import {HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, switchMap} from 'rxjs/operators';
import {Observable} from 'rxjs/Observable';
import {ConfigService} from '../services/utils/config.service';
import {environment} from '../../environments/environment';
import {Router} from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    private get refreshTokenUrl() {
        return `${environment.API}${environment.RESOURCES.REFRESH}`;
    }

    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private router: Router
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.includes(this.refreshTokenUrl) || req.url.includes('/geoserver/')) {
            return next.handle(req);
        }

        const accessToken = sessionStorage.getItem('jwt');

        if (accessToken && this.isTokenExpired(accessToken)) {
            return this.http.post<{ token: string }>(this.refreshTokenUrl, {}, {withCredentials: true}).pipe(
                switchMap(res => {
                    const newToken = res.token;
                    sessionStorage.setItem('jwt', newToken);

                    const clonedReq = req.clone({
                        setHeaders: {Authorization: `Bearer ${newToken}`}
                    });
                    return next.handle(clonedReq);
                })
            );
        }

        const authReq = accessToken
            ? req.clone({setHeaders: {Authorization: `Bearer ${accessToken}`}})
            : req;

        return next.handle(authReq).pipe(
            catchError((error) => {
                if (error.status === 401 && this.isTokenExpired(accessToken)) {
                    sessionStorage.clear();
                    this.router.navigateByUrl('/');
                }
                return Observable.throw(error);
            })
        );
    }

    private isTokenExpired(token: string): boolean {
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const expiry = payload.exp;
            const now = Math.floor(Date.now() / 1000);
            return now >= expiry;
        } catch (e) {
            return true;
        }
    }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/interceptor/AuthInterceptor.ts